import * as React from "react";
import { DataGrid, GridFooterContainer } from "@mui/x-data-grid";
import { nanoid } from "@reduxjs/toolkit";
import { FormatWithPrecision } from "utility/numberFormatting";
import { DataGridCell } from "../DataGridCell/DataGridCell";
import { DataGridHeader } from "../DataGridHeader/DataGridHeader";
import { TaxGridToolbar } from "../TaxGridToolbar/TaxGridToolbar";

export const TaxSummaryFooter = (props) => {   
    function getRowId() { return nanoid(); }

    const renderColHeader = (params) => (
        <DataGridHeader value={params.colDef.headerName}/>
    );
 
    const vatColumns = [
        { field: 'index', headerName: '', flex: 1, width:150, editable: false, filterable: false, sortable: false, type:'string', headerAlign: 'right', align: 'right',
            renderHeader: renderColHeader,
        },
        { field: 'vat', headerName: 'VAT(%)', width:150, editable: false, filterable: false, sortable: false, type:'string', headerAlign: 'right', align: 'right',
            renderHeader: renderColHeader, 
            renderCell: (params)=> <DataGridCell value={params.row.vat.name}/>,
        },
        { field: 'net', headerName: 'Wartość netto', width: 150, editable: false, filterable: false, sortable: false, type:'number',  headerAlign: 'right', align: 'right',
            renderHeader: renderColHeader, 
            renderCell: (params)=> <DataGridCell value={FormatWithPrecision(params.row.netAmount)}/>,
        },
        { field: 'tax', headerName: 'Kwota VAT', width: 150, editable: false, filterable: false, sortable: false, type:'number', headerAlign: 'right', align: 'right',
            renderHeader: renderColHeader,
            renderCell: (params)=> <DataGridCell value={FormatWithPrecision(params.row.taxAmount)}/>,
        },
        { field: 'gross', headerName: 'Wartość brutto', width: 150, editable: false, filterable: false, sortable: false, type:'number', headerAlign: 'right', align: 'right',
            renderHeader: renderColHeader, 
            renderCell: (params)=> <DataGridCell value={FormatWithPrecision(params.row.grossAmount)}/>,
        }
    ];
 
  return (
    <GridFooterContainer>
        <DataGrid
            sx={{ color:'text.main', border: 0, '& .MuiDataGrid-iconSeparator': { display: 'none'} }}
            autoHeight={true} getRowId={getRowId} rows={props.vat} rowHeight={32} getRowHeight={() => 'auto'}
            headerHeight={36} hideFooterPagination={true} hideFooter={true} columns={vatColumns}
            disableSelectionOnClick disableColumnFilter disableColumnMenu experimentalFeatures={{ newEditingApi: true }}
            components={{ Toolbar: TaxGridToolbar }}
        />
    </GridFooterContainer>
  );
}